export const ADMINISTRATORS = [
  "RS_ADMINISTRATION",
  "STK_ADMINISTRATION"
];

export const SITRACK = [  
  "STK_ADMINISTRATION"
];